/**
 * Order Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';


// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import {
  clearOrderAction,
  getAllOrderItemsAction,
  getOrderWithIdAction,
  updateOrderStatusActions,
  getLogsAction,
  getCatAction,getVitrinOrderWithIdAction,
} from '../orders/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError,
  makeSelectAllOrderItems,
  makeSelectLogs,
  makeSelectCatList,
} from '../orders/selectors';

import Client from 'client-sdk/src/client';


//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Typography,
  Paper,
  Grid,
  CircularProgress,
  Radio,
  RadioGroup,
  Select,
  FormControl,
  FormControlLabel,
  Card,
  CardHeader,
  CardContent,
  Dialog,
  DialogContent,
  IconButton,
  TextField,
  Divider,
  DialogActions,
  Button,
  TextareaAutosize,
  MenuItem,
  Input,
} from '@material-ui/core';

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from '@material-ui/lab';

// Icon
import Icon from '@mdi/react';
import {
  mdiPencilOutline,
  mdiClose,
  mdiPackageVariant,
  mdiDotsHorizontalCircleOutline,
  mdiPackageVariantClosed,
  mdiTruckFastOutline,
  mdiMapMarkerCheckOutline,
  mdiClipboardAlertOutline,
  mdiClipboardArrowDownOutline,
  mdiClipboardCheckOutline,
  mdiPlusBoxMultipleOutline,
  mdiAccountArrowRight,
  mdiStoreOutline,
  mdiCashMultiple,
  mdiChevronLeft,
  mdiReceipt,
} from '@mdi/js';

// Components
import ListVitrinOrderItems from './listVitrin';
import InventoryItemsList from './inventoryItemsList';
import Can from '../../components/Can';

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../utils/rulesOrderStatus';

// Helper
import { translate, formaterPhoneNumber } from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type

import { Status, Log } from '../orders/interfaces';
import { SelectorProps, Props } from './interfaces';
import CSV from './csv';
import { getInventoryItemsWithSerialAction } from '../parcels/actions';
import { makeSelectInventoryItemsWithSerialList } from '../parcels/selectors';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import handleNotfication from '../../utils/handleNotfication.tsx';
import handleError from '../../utils/handleError';
import Modal from '../../components/Modal';
import classes from './index.module.scss';
import windowSize from '../../utils/hook/useWindowResize';
import DetailsMobile from './mobileView';
import { DialogTitle } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import AxiosClient from 'client-sdk/src/client';
import { FileUploadTicketsRequestBuilder, PostAllTicketsRequestBuilder } from 'client-sdk/src/helpical/categories';

const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته‌بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  BUNDLED: mdiPackageVariantClosed, //' بسته‌بندی شده برای راننده',
  CANCELLED: mdiClose, //'لغو شده',
  DELIVERED_TO_POST: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED_TO_CENTER: mdiDotsHorizontalCircleOutline, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: mdiDotsHorizontalCircleOutline, //'تامین در مرکز',
  PACKAGED: mdiPackageVariant, //'بسته‌بندی شده برای مشتری',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  LOADED: mdiTruckFastOutline, // 'در حال تحویل',
  NOT_DELIVERED: mdiClipboardAlertOutline, //'تحویل داده نشده',
  ORDERED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  RETURNED: mdiClipboardArrowDownOutline, //'بازگردانده شده',
  PICKED: mdiPlusBoxMultipleOutline, //'برداشته شده',
  ASSIGNED: mdiAccountArrowRight, //'برداشته شده',
};

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [openInventoryItems, setOpenInventoryItems] = useState(
    false as boolean
  );
  const [postTrackingCode, setPostTrackingCode] = useState<null | string>(null);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();
  const [openMsg, setOpenMsg] = useState(false);
  const [file, setFile] = useState<any>('');
  const { register, control, errors, handleSubmit, setValue, getValues, watch } =
    useForm({
      defaultValues: {
        file: null,
        subject: '1',
        msg: ''
      },
    });
  const [loading, setLoading] = useState(true)
  const token = localStorage.getItem('token') || '';



  const handleCloseModal = () => {
    setOpenMsg(false);
    setFile(null);
    setValue('file', null);

  }

  const handleShowInventoryItems = (data: any) => {
    props.getInventoryItems({
      orderItemId: { equals: data.id },
      callback: () => setOpenInventoryItems(true),
    });
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };
  const history = useHistory();

  useEffect(() => {
    const { id } = props.match.params;
    props.vitrinOrderWithIdActionDispatch(id);
    props.getOrderItemsActionDispatch({
      'orderId.equals': id,
      page: 0,
      size: 1000,
    });
  }, []);

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  useEffect(() => {
    props.getLogsDispatch(props.match.params.id);
    if (props.order?.postTrackingCode) {
      setPostTrackingCode(props.order?.postTrackingCode);
    }
  }, [props.order]);

  useEffect(() => {
    if (authContext.user.role !== 'SELLER_ADMIN') {

      props.getCatDispatch();
    }

  }, []);



  useEffect(() => {
    return () => {
      props.clearOrderActionDispatch();
    };
  }, []);





  const handleChangeFileInput = (event: any) => {
    setFile(event.target.files[0]);
  };

  const onSubmit = async (data) => {
    try {

      setLoading(true);
      let fileData = new FormData();
      fileData.append("file", file);
      const makeRequest = new PostAllTicketsRequestBuilder()
        .params({

        })
        .data({
          orderId: props.match.params.id,
          parcelId: 0,
          categoryId: data.subject,
          message: data.msg
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      if (file) {
        const fileTicketRequest = new FileUploadTicketsRequestBuilder()
          .id(
            response.data.id
          )
          .data(fileData)
          .build();
        await client.execute(fileTicketRequest);
      }

      handleNotfication('تیکت با موفقیت ایجاد شدند', 'success');
      history.push(`/orders/${props.match.params.id}`);
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }


      handleError(err.response);
    } finally {
      setFile(null);
      setOpenMsg(false);
      setLoading(false);
      setValue('file', null);

    }

  };

  const handleRemoveFile = () => {
    setFile(null)
    setValue('file', null);

  }



  return isMob ? (
    <DetailsMobile {...props} />
  ) : (
    <div className={classes.root}>
      <Grid
        className={classes.topBox}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              جزيیات سفارش
              <span data-cy="orderIdHead"> &nbsp; {props.order.id}</span>
            </Typography>
            {authContext.user.role !== 'SELLER_ADMIN' &&
              <Button
                variant="contained"
                size="large"
                color="primary"
                style={{ marginLeft: '172px' }}
                onClick={() => setOpenMsg(true)}
              >
                {`ارسال پیام`}
              </Button>}
          </div>
        </Paper>
      </Grid>

      <Grid
        container
        lg={12}
        md={12}
        spacing={4}
        style={{ marginBottom: '32px' }}
      >
        <Grid item lg={3} md={3} sm={12} xs={12}>
          {props.order?.deliveryType === 'COURIER' &&
            props.order?.orderTPLType === 'CHAPAR' && (
              <Card className={classes.card}>
                <CardHeader
                  avatar={
                    <Typography className={classes.typographyCards}>
                      مشخصات مرسوله چاپار
                    </Typography>
                  }
                />
                <CardContent style={{ paddingBottom: '10px' }}>
                  <Grid xs={12} sm={12} lg={12} spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <div className={classes.item}>
                        <span className={classes.label}>
                          {'کد رهگیری چاپار:  '}
                        </span>
                        {JSON.parse(props.order?.tplTrackingCode).map(
                          (tplTrackCode, index) => {
                            return (
                              <span data-cy={'tplTrackingCode'}>
                                {tplTrackCode}
                              </span>
                            );
                          }
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}
          {props.order?.deliveryType !== 'COURIER' && (
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    مشخصات مرسوله پستی
                  </Typography>
                }
              />
              <CardContent style={{ paddingBottom: '10px' }}>
                <Grid xs={12} sm={12} lg={12} spacing={2}>
                  {props.order?.postOrders?.map((order, index) => {
                    return (
                      <>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.item}>
                            <span style={{ fontSize: '18px' }}>
                              بسته {index + 1}
                            </span>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.item}>
                            <span className={classes.label}>
                              {'وضعیت مرسوله:  '}
                            </span>
                            <span data-cy={'orderStatus' + index}>
                              {translate(order.orderStatus, 'order')}
                            </span>
                          </div>
                        </Grid>
                        {order.barcode && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'کد رهگیری پست:  '}
                              </span>
                              <span data-cy={'barcode' + index}>
                                {order.barcode}
                              </span>
                            </div>
                          </Grid>
                        )}
                        {order.weight && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'وزن پستی (گرم):  '}
                              </span>
                              <span data-cy={'orderWeight' + index}>
                                {order.weight}
                              </span>
                            </div>
                          </Grid>
                        )}
                        {order.totalPrice && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'هزینه پست (ریال):  '}
                              </span>
                              <span data-cy="totalPrice">
                                {order.totalPrice}
                              </span>
                            </div>
                          </Grid>
                        )}
                      </>
                    );
                  })}
                </Grid>
              </CardContent>
            </Card>
          )}
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات سفارش
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '10px' }}>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'وضعیت تحویل:  '}</span>
                  <Can
                    role={authContext.user.role}
                    perform="orders:changeOrderStatus"
                    yes={() => (
                      <FormControl style={{ width: '50%' }}>
                        <Icon
                          path={mdiPencilOutline}
                          size={1}
                          className={classes.changStatusIcon}
                        />
                        <Select
                          className={classes.changStatusBox}
                          fullWidth
                          inputProps={{
                            name: 'name',
                            id: 'uncontrolled-native',
                          }}
                          name={'status'}
                          id={props.order.rubikaId}
                          value={[{}]}
                          IconComponent={() => null}
                          renderValue={() => (
                            <span className={classes.renderValue}>
                              {translate(props.order.status, 'order')}
                            </span>
                          )}
                        >
                          <RadioGroup
                            className={classes.radioGroup}
                            aria-label={'status'}
                            name={'status$'}
                            value={'item'}
                            onChange={(
                              e: React.ChangeEvent<{ value: unknown }>
                            ) =>
                              handleOpenConfirmUpdateState(
                                `"${e.target.value}"` as Status
                              )
                            }
                          >
                            {rulesOrderStatus[props.order.status]?.map(
                              (item: any, index: number) => (
                                <FormControlLabel
                                  className={classes.radioGroupItem}
                                  key={index}
                                  checked={props.order.status === item}
                                  value={item}
                                  disabled={
                                    rulesAdminChangeOrderStatus[
                                      authContext.user.role
                                    ].indexOf(item) === -1
                                  }
                                  control={<Radio />}
                                  label={translate(item, 'order')}
                                />
                              )
                            )}
                          </RadioGroup>
                        </Select>
                      </FormControl>
                    )}
                    no={() => (
                      <span style={{ textAlign: 'left' }} data-cy="status">
                        {translate(props.order.status, 'order')}
                      </span>
                    )}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شیوه پرداخت :  '}</span>

                  <span>{translate(props.order.paymentType, 'cod')}</span>
                </div>
              </Grid>
              {props.order?.paymentType === 'COD' && (
                <Grid item xs={12} sm={12} lg={12} spacing={2}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'مبلغ فاکتور:  '}</span>

                    <span>{props.order.codValue}</span>
                  </div>
                </Grid>
              )}
              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'کدپیگیری:  '}</span>
                  <span data-cy="trackingCode">
                    {props.order?.trackingCode}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'تعداد بسته:  '}</span>
                  <span data-cy="trackingCode">
                    {props.order?.orderPackages?.length}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نوع ارسال:  '}</span>
                  <span data-cy="deliveryType">
                    {translate(props.order?.deliveryType)}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{' تاریخ ثبت سفارش:  '}</span>
                  <span data-cy="registrationDate">
                    {props.order.registrationDate &&
                      `${jMoment(props.order.registrationDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'تاریخ تحویل سفارش:  '}
                  </span>
                  <span data-cy="deliveryDate">
                    {props.order.deliveryDate &&
                      `${jMoment(props.order.deliveryDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {' بازه تحویل سفارش:  '}
                  </span>
                  <span data-cy="deliveryStartTime">
                    {props.order.deliveryStartTime &&
                      jMoment(props.order.deliveryStartTime, 'hh:mm:ss')
                        .locale('fa')
                        .format('HH:mm')}
                    {' - '}
                    {props.order.deliveryEndTime &&
                      jMoment(props.order.deliveryEndTime, 'hh:mm:ss')
                        .locale('fa')
                        .format('HH:mm')}
                  </span>
                </div>
              </Grid>
              {props.order.description && (
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'توضیحات:  '}</span>
                    <span data-cy="description">
                      {props.order.description && props.order.description}
                    </span>
                  </div>
                </Grid>
              )}
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات سفارش‌دهنده
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '10px' }}>
              <Grid xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نام:   '}</span>

                  <span data-cy="customerName">{props.order.customerName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'کد ملی:'}</span>
                  <span data-cy="customerNationalCode">
                    {props.order?.customerNationalCode}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{' شماره ثابت:     '}</span>
                  <span dir="ltr" data-cy="customerPhoneNumber">
                    {props.order?.customerPhoneNumber}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شماره همراه:  '}</span>
                  <span data-cy="customerMobileNumber">
                    {formaterPhoneNumber(props.order.customerMobileNumber)}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{' کد پستی:    '}</span>
                  <span data-cy="customerZipCode">
                    {props.order?.customerZipCode}
                  </span>
                </div>
              </Grid>
              {/* <Can
                role={authContext.user.role}
                perform="orders-info:more-info"
                yes={() => <></>}
              /> */}
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شهر:  '}</span>

                  <span data-cy="customerCity">
                    {props.order?.customerCity}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'استان:  '}</span>

                  <span data-cy="customerProvince">
                    {props.order?.customerProvince}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.item}>
                  <span className={classes.label} style={{ alignSelf: 'start' }}>
                    {'آدرس:  '}
                  </span>
                  <span
                    style={{ textAlign: 'left', marginRight: '30px' }}
                    data-cy="customerAddress"
                  >
                    {props.order.customerAddress && props.order.customerAddress}
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={9} md={9} sm={12} xs={12} spacing={2}>
          <Card className={classes.card} style={{ padding: 0 }}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  لیست کالاهای سفارش {props.order.id}
                </Typography>
              }
              action={
                <Grid item xs={12} style={{ marginTop: '15px' }}>
                  <div style={{ textAlign: 'left', marginBottom: '-20px' }}>
                    <Can
                      role={authContext.user.role}
                      perform="orders:downloadReportCSV"
                      yes={() => (
                        <>
                          <CSV
                            // ordersDispatch={props.order}
                            data={props.orderItems}
                            loading={props.loading}
                          />
                        </>
                      )}
                    />
                    {
                      props.order.orderType === 'FROM_CENTER' && <Can
                        perform="orderExit:print"
                        role={authContext.user.role}
                        yes={() => (
                          <Link
                            to={`/orders/exit-receipts/${props.order.id}`}
                            target="_blank"
                            style={{ textDecoration: 'none', margin: '0px 10px' }}
                          >
                            <Button
                              variant="contained"
                              color="secondary"
                              startIcon={<Icon path={mdiReceipt} size={1} />}
                            >
                              {'چاپ رسید خروج'}
                            </Button>
                          </Link>
                        )}
                      />
                    }

                  </div>
                </Grid>
              }
            />

            <CardContent
              style={{ margin: '14px 0  0', padding: '0' }}
              className={classes.cardContentList}
            >
              <Grid style={{ width: '100%', margin: '0' }} container spacing={3}>
                {props.loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : props.order.childOrders?.length > 0 ? (
                  props.order.childOrders.map((childOrder, index) => {
                    return (
                      <React.Fragment>
                        <div>
                          {`لیست کالاهای ${childOrder.fulfillmentWarehouseName}`}
                        </div>
                        <ListVitrinOrderItems
                          data={childOrder.productInfos}
                          showItems={data => handleShowInventoryItems(data)}
                        />
                      </React.Fragment>
                    );
                  })
                ) : (
                  props.order?.productInfos && (
                    <>
                      <ListVitrinOrderItems
                        data={props.order?.productInfos}
                        showItems={data => handleShowInventoryItems(data)}
                      />
                    </>
                  )
                )}
              </Grid>
            </CardContent>
          </Card>
          <Card className={classes.card} style={{ marginTop: '24px' }}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  تاریخچه سفارش
                </Typography>
              }
            />
            <CardContent style={{ padding: '0', marginTop: '-10px' }}>
              <Grid container style={{ padding: '0' }}>
                <Grid item xs={12}>
                  <Timeline align="left" style={{ minWidth: '500px' }}>
                    {props.logs
                      ?.slice()
                      .reverse()
                      .map((log: Log, index: number) => (
                        <TimelineItem
                          className={classes.missingOppositeContent}
                          key={index}
                          data-cy="timeLineItem"
                        >
                          <TimelineSeparator>
                            <TimelineDot
                              style={{
                                backgroundColor: colorStatus[log.newStatus],
                                border: index === 0 ? 'solid 4px #DF9234' : '',
                              }}
                            >
                              <Icon path={iconStatus[log.newStatus]} size={1} />
                            </TimelineDot>
                            {index !== props.logs?.length - 1 ? (
                              <TimelineConnector />
                            ) : (
                              ''
                            )}
                          </TimelineSeparator>
                          <TimelineContent className={classes.paperHistory}>
                            <div style={{ padding: '10px' }}>
                              <div className={classes.contentBox}>
                                <div style={{ flex: 2, textAlign: 'right' }}>
                                  <span className={classes.contentlabel}>
                                    وضعیت سفارش:
                                  </span>
                                  <span data-cy="status">
                                    {translate(log.newStatus, 'order')}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    flex: 1,
                                    textAlign: 'right',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <span className={classes.contentlabel}>
                                    کاربر:
                                  </span>
                                  <Can
                                    role={authContext.user.role}
                                    perform="user-name:dontShowInLogs"
                                    no={() => (
                                      <>
                                        <span>{log.modifierName}</span>
                                        <span>
                                          {' '}
                                          &nbsp; &nbsp;- &nbsp; &nbsp;
                                        </span>
                                      </>
                                    )}
                                  />
                                  <span data-cy="role">
                                    {translate(log.modifierRole, 'user')}
                                  </span>
                                </div>
                                <Typography
                                  component="div"
                                  className={classes.titleBox}
                                  style={{ flex: 1 }}
                                >
                                  {log.time &&
                                    jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                                      .locale('fa')
                                      .format('jYYYY/jMM/jDD - HH:mm')}
                                </Typography>
                              </div>
                            </div>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                  </Timeline>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth='lg'
        style={{ padding: '16px' }}

      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleCloseModal ? (
              <IconButton
                aria-label="close"
                onClick={handleCloseModal}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>


          <Grid item xs={12} style={{ marginTop: '16px' }}>
            <p style={{ marginTop: '-8px', marginLeft: '46px' }}>

              ایجاد پیام برای سفارش شناسه {props.match.params.id}
            </p>

          </Grid>
          <Divider style={{ width: '100%', marginTop: '16px' }} />
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent style={{ paddingTop: '0' }}>
            <Link to={`/orders/helpdesk/${props.match.params.id}`} style={{ textDecoration: 'none' }}>
              <Typography style={{ marginBottom: '16px' }}>
                مشاهده پیام‌های ارسال شده قبلی برای این سفارش
                <Icon path={mdiChevronLeft} size={1} style={{ marginBottom: '-8px' }} />
              </Typography>
            </Link>
            <Controller
              style={{ width: '100%' }}
              control={control}
              name='subject'
              label='موضوع'
              rules={{ required: true }}
              as={
                <TextField
                  style={{ marginTop: '16px', marginBottom: '16px' }}
                  fullWidth
                  variant='outlined'
                  select
                >
                  {
                    props.catList?.map(item => {
                      return (

                        <MenuItem
                          value={item.id}
                        >
                          {item.name}
                        </MenuItem>
                      )
                    })
                  }

                </TextField>
              }
            />

            <Controller
              control={control}
              id='msg'
              name='msg'
              rules={{ required: true }}
              as={
                <TextField inputProps={{
                  style: {
                    height: '200px',
                    padding: '0 14px',
                  }
                }} margin='normal' multiline label='پیام خود را وارد کنید' variant='outlined' fullWidth />
              }
            />
            <Grid md={6}>
              <label htmlFor="file" className={classes.choosebtn} >
                <Button variant='contained' size='small' component="span" >
                  انتخاب فایل
                </Button>
                <input
                  id="file"
                  type="file"
                  name="file"
                  ref={register}
                  onChange={handleChangeFileInput}
                  className={classes.uploadInput}
                />
              </label>


            </Grid>
            {
              file &&
              <Grid style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between' }}>
                <IconButton
                  aria-label="close"
                  style={{ marginLeft: 'auto' }}
                  onClick={handleRemoveFile}
                >
                  <Icon path={mdiClose} size={1} />
                </IconButton>
                <span style={{ marginTop: '14px' }}>
                  <span style={{ fontWeight: 'bold' }} > {file.name} </span>
                  <span>( {file.size} KB )</span>
                </span>
              </Grid>
            }

            <Divider style={{ width: '100%', marginTop: '16px' }} />
          </DialogContent>
          <DialogActions>
            <Grid
              container
              spacing={2}
              direction='row-reverse' style={{ marginBottom: '8px' }}
            >
              <Button
                type='submit'
                variant="contained"
                size="large"
                color="primary"
                style={{ marginLeft: '24px' }}
              >
                {`ارسال پیام`}
              </Button>

            </Grid>
          </DialogActions>
        </form>

      </Dialog>

      <Modal
        onClose={() => setOpenInventoryItems(false)}
        maxWidth="md"
        open={openInventoryItems}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiStoreOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={<InventoryItemsList data={props.inventoryItems} />}
      />
    </div >
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  catList: makeSelectCatList(),
  order: makeSelectOrder(),
  orderItems: makeSelectAllOrderItems(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  inventoryItems: makeSelectInventoryItemsWithSerialList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getCatDispatch: (payload: any) => dispatch(getCatAction(payload)),
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    // orderWithIdActionDispatch: (id: number) =>
    //   dispatch(getOrderWithIdAction({ id })),
    vitrinOrderWithIdActionDispatch: (id: number) =>
      dispatch(getVitrinOrderWithIdAction({ id })),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
      callback?: () => void;
    }) => dispatch(updateOrderStatusActions(payload)),
    clearOrderActionDispatch: () => dispatch(clearOrderAction()),
    getInventoryItems: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithSerialAction(payload)),
    getOrderItemsActionDispatch: (payload: any) =>
      dispatch(getAllOrderItemsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
